import React, {useContext} from 'react';
import {Modal, Platform, StyleSheet, TouchableOpacity, View} from 'react-native';
import DrawerMenu from './DrawerMenu';
import {WebMenuContext} from './WebMenuContext';

type Props = {
  navigation: any;
};

/**
 * Web/PWA side menu. Avoids @react-navigation/drawer on web, which misbehaves
 * under RTL in Chrome Android (stuck open panel + empty opposite drawer).
 */
export default function WebSideMenu({navigation}: Props) {
  const menu = useContext(WebMenuContext);

  if (Platform.OS !== 'web') {
    return null;
  }

  return (
    <Modal
      visible={menu.visible}
      transparent
      animationType="fade"
      onRequestClose={menu.close}>
      <View style={styles.root}>
        <TouchableOpacity style={styles.backdrop} activeOpacity={1} onPress={menu.close} />
        {/* Absolute right — independent of flex RTL mirroring. */}
        <View style={styles.panel}>
          <DrawerMenu
            navigation={navigation}
            onClose={menu.close}
            nestedInDrawer={false}
          />
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.45)',
  },
  panel: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: 280,
    maxWidth: '80%',
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOpacity: 0.25,
    shadowRadius: 8,
    shadowOffset: {width: -2, height: 0},
    elevation: 8,
  },
});
